import React, { useState } from "react";
import {
    Collapse,
    Tooltip,
    Typography,
} from "@material-ui/core";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { getLocalizedString } from "@icarius-localization/strings";
import Counter from "../../../counter";
import ActivityItem from "./activityItem";
import PendingQAndAIndicator from "./pendingQAndAIndicator";
import { ACTIVITY_STATUS_OPTIONS } from "@icarius-pages/myTraining/constants";

const ModuleItem = (props) => {

    const {
        isInstructor,
        isPreselected,
        selectedActivityId,
        data,
        handleOpenActivity,
    } = props;

    const [expanded, setExpanded] = useState(isPreselected);

    const isCompleted = data.activities.every((activity) => activity.status === ACTIVITY_STATUS_OPTIONS.completed);

    return (
        <>
            <div
                style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 15,
                    color: "var(--mainText)"
                }}
                onClick={() => setExpanded((prev) => !prev)}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                    }}
                >
                    {
                        isCompleted ?
                            <Tooltip title={getLocalizedString("complete")}>
                                <CheckCircleIcon
                                    style={{
                                        color: "var(--ownGreen)",
                                    }}
                                />
                            </Tooltip>
                            :
                            <BookmarkIcon />
                    }
                    <div>
                        <Typography style={{ fontSize: 14 }}>
                            {data.name}
                        </Typography>
                        <PendingQAndAIndicator
                            value={data.hasPendingQuestionsOrAnswers}
                            isInstructor={isInstructor}
                        />
                    </div>
                    {
                        isInstructor &&
                        <Counter
                            value={data.pendingActions}
                            label={getLocalizedString("pendingGrades")}
                        />
                    }
                </div>
                {
                    expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
                }
            </div>
            <Collapse in={expanded}>
                <div
                    style={{
                        marginTop: 10,
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                    }}
                >
                    {
                        data.activities?.map((activity, activityIndex) => {
                            return (
                                <div
                                    key={activityIndex}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 5,
                                    }}
                                >
                                    <ActivityItem
                                        isInstructor={isInstructor}
                                        isSelected={activity.id === selectedActivityId}
                                        data={activity}
                                        handleOpen={handleOpenActivity}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
            </Collapse>
        </>
    );
}

export default ModuleItem;